import PropTypes from 'prop-types'

import { PortalBody } from 'shared/utils/portal'

import { useNotyCore } from './hooks/useNotyCore'

import { NotyContext } from './Noty.context'
import NotyConfirm from './components/NotyConfirm'
import NotyRenderer from './components/NotyRenderer'

function Noty({ children, id }) {
  const { notys, confirm, contextValue } = useNotyCore()

  return (
    <NotyContext.Provider value={contextValue}>
      {children}
      <PortalBody id={`${id}-noty`}>
        <NotyRenderer notys={notys} />
        <NotyConfirm {...confirm} />
      </PortalBody>
    </NotyContext.Provider>
  )
}

Noty.propTypes = {
  id: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
}

export default Noty
